<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZueRXg/tc-custom/9781459218130.jpg?1703850116886" alt="This image is the cover for the book Accidental Father"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Accidental Father
      </h1>
      <p class="bookDescription body article font2">
        <b>OUT OF THE SHADOWS</b><br/><br/>Sarah Harper gasped when she saw the rugged lawman on the porch of her bed-and-breakfast. She didn't know his last name, but for three years his blue eyes had haunted her. She saw them every night in her dreamsand every morning, twinkling in her toddler's face.<br/><br/>Jake Russell sought only a roof over his head and a warm bed. He never expected it to be her roofor her bed. But Sarah had a hold on him, and he couldn't turn his back on her. Not when he suspected she was in dangerand that her child was his child, too.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauren Nichols
      </h2>
      
      <p class="authorDescription body article">Once upon a time, Lauren Nichols wanted to to illustrate children's books. But when one publisher finally gave her a chance to submit her sketches--if she wrote an accompanying story--Lauren fell in love with fiction writing. She now writes mystery, romance and science fiction short stories for national magazines, and romantic suspense novels for Harlequin. Lauren loves creating emotional romances with mystery and suspense elements that keep readers guessing until the very end.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37eda002